/**
 * @generated SignedSource<<43c06b7fe1071bcd18ff894dcb0edbe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType$data = {
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType">;
  readonly " $fragmentType": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType";
};
export type workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType$key = {
  readonly " $data"?: workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_issueType"
    }
  ],
  "type": "JiraIssueType"
};

(node as any).hash = "2291f6a1b2e0e539ce7eb0194f65644e";

export default node;
